<template>
  <v-container fluid>
    <material-card icon="mdi-calendar-edit" inline title="Create Calendar Activity">
      <v-card-actions>
        <router-link :to="{ name: 'eventCalendarList' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
      <v-card flat class="px-2">
        <form @submit.prevent="save">
          <v-row>
            <v-col cols="12" md="6" lg="4">
              <label class="body-2 font-weight-medium">Event Type <span class="error--text">*</span></label>
              <v-autocomplete
                class="my-0 py-1"
                placeholder="--Select--"
                @change="clearAllData()"
                name="selectCalendarType"
                required
                v-model="calendarID"
                item-value="id"
                :items="calendarTypeArray"
                key="id"
                item-text="name"
              >
              </v-autocomplete>
            <v-col cols="12" mb="3" lg="6" v-if="isPTMSelected" class="pt-0 mt-0" style="margin-top: -12px;">
              <label class="body-2 font-weight-medium">Select Term <span class="error--text">*</span></label>
              <v-autocomplete  class="my-0 py-1"
                v-model="selectedTerm"
                :items="termOptions"
                outlined
                dense
                required
              ></v-autocomplete>
            </v-col>
          </v-col>
            <v-col cols="12" lg="4" md="6" v-if="this.calendarID === 2">
              <label class="body-2 font-weight-medium"> Type <span class="error--text">*</span></label>
              <v-autocomplete
                item-text="userOfType"
                item-value="userOfType"
                :items="userOfType"
                placeholder="--Select--"
                @change="clearbithdayData()"
                name="userSelect"
                required
                class="my-0 py-1"
                v-model="UserType"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" lg="4" md="6" v-if="this.UserType === 'STAFF' && this.calendarID === 2">
              <label class="body-2 font-weight-medium"> Select Staff <span class="error--text">*</span> </label>
              <v-autocomplete return-object class="my-0 py-1" placeholder="--Select--" required name="staffSelect" v-model="staffID" item-value="id" :items="staffData" key="id" item-text="name">
              </v-autocomplete>

              <!-- :v-bind="id" -->
            </v-col>
            <v-col cols="12" lg="4" md="6" v-if="this.UserType === 'STUDENT' && this.calendarID === 2">
              <label class="body-2 font-weight-medium"> Class <span class="error--text">*</span> </label>
              <v-autocomplete
                class="my-0 py-1"
                placeholder="--Select--"
                name="classSelect"
                required
                v-model="selectedClassID"
                v-on:change="changeSections()"
                item-value="id"
                :items="classes"
                key="id"
                item-text="name"
              >
              </v-autocomplete>
              <!-- :v-bind="id" -->
            </v-col>
            <v-col cols="12" lg="4" md="6" v-if="this.UserType === 'STUDENT' && this.calendarID === 2">
              <label class="body-2 font-weight-medium"> Select Section <span class="error--text">*</span> </label>
              <v-autocomplete
                class="my-0 py-1"
                placeholder="--Select--"
                v-on:change="students()"
                required
                name="sectionSelect"
                v-model="selectedSectionID"
                item-value="id"
                :items="classWiseSections"
                item-text="name"
                key="id"
              >
              </v-autocomplete>
              <!-- :v-bind="id" -->
            </v-col>
            <v-col cols="12" lg="4" md="6" v-if="this.UserType === 'STUDENT' && this.calendarID === 2">
              <label class="body-2 font-weight-medium"> Select Student <span class="error--text">*</span> </label>
              <v-autocomplete
                return-object
                item-value="id"
                class="my-0 py-1"
                placeholder="--Select--"
                required
                name="sectionSelect"
                v-model="selectedStudent"
                :items="studentArray"
                key="id"
                item-text="name"
              >
              </v-autocomplete>
              <!-- :v-bind="id" -->
            </v-col>
            <v-col cols="12" lg="4" md="6">
              <label class="body-2 font-weight-medium"> Date <span class="error--text">*</span></label>
              <custom-date-picker v-model="fromDate" required />
            </v-col>
            <v-col v-if="this.calendarID === 2" cols="12" lg="4" md="6">
              <label class="body-2 font-weight-medium">Any Message </label>
              <v-text-field placeholder="Write any message" class="my-0 py-1" single-line v-model.trim="anyMassage"></v-text-field>
            </v-col>
            <v-col v-if="this.calendarID !== 2" cols="12" lg="4" md="6">
              <label class="body-2 font-weight-medium"> Title <span class="error--text">*</span></label>
              <v-text-field placeholder="Event Title" class="my-0 py-1" single-line v-model.trim="title" required></v-text-field>
            </v-col>
            <v-col v-if="this.calendarID !== 2" cols="12" lg="4" md="6">
              <label class="body-2 font-weight-medium"> Sub Title <span class="error--text">*</span></label>
              <v-text-field placeholder="Event Sub Title" class="my-0 py-1" single-line v-model.trim="subTitle" required></v-text-field>
            </v-col>
            <v-col cols="12" md="12" lg="8">
              <label class="body-2 font-weight-medium">Description </label>
              <v-textarea rows="3" placeholder="Write Description" clearable v-model.trim="discription"  clear-icon="mdi-close-circle" single-line class="my-0 py-1"></v-textarea>
            </v-col>
            <v-col cols="12" md="6" lg="4" v-if="this.calendarID === 3">
              <label class="body-2 font-weight-medium">Select File</label>
              <v-file-input :messages="['(max file size allowed 20MB)']" class="my-0 py-1" v-model="dropFile" accept="image/*" @input="onFilechange()" show-size placeholder="Click to Upload"></v-file-input>
            </v-col>
            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-spacer />
                <v-btn elevation="1" type="submit" color="primary" :disabled="hasClicked">
                  <v-icon left> mdi-content-save </v-icon>
                  Create
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form>
      </v-card>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import MaterialCard from '@/components/template/MaterialCard'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import Utils from '@/utils'
import moment from 'moment'
import _ from 'lodash'
// import moment from 'moment'
export default {
  name: 'eventCalendar',
  components: {
    MaterialCard,
    CustomDatePicker
  },
  data () {
    return {
      total: 0,
      dropFile: [],
      franchiseeID: '',
      fromDate: moment().format('YYYY-MM-DD'),
      UserType: '',
      staffID: '',
      franchiseeArr: [],
      academicYearID: '',
      selectedSectionID: '',
      studentbirthdate: '',
      classWiseSections: [],
      studentArray: [],
      selectedClassID: '',
      selectedStudent: '',
      subTitle: '',
      discription: '',
      academicYears: [],
      calendarTypeArray: [],
      classID: '',
      title: '',
      classes: [],
      sections: [],
      tempArray: [],
      saveClass: '',
      saveSection: '',
      anyMassage: '',
      studentSection: '',
      calendarID: '',
      staffData: [],
      hasClicked: false,
      loader: true,
      isWrite: false,
      isLoading: false,
      userOfType: ['STAFF', 'STUDENT'],
      termOptions: ['Term1', 'Term2', 'Term3', 'Term4'],
      selectedTerm: null
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getClassList()
    // await this.getFranchiseeList()
    // await this.getYear()
    await this.getCalenderType()
    await this.onFranchiseeChange()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    }),
    isPTMSelected () {
      const selected = this.calendarTypeArray.find(e => e.id === this.calendarID)
      return selected && selected.name === 'PTM (Parent Teacher Meeting)'
    }
  },

  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
      this.clearAllData()
    },
    getStaff: async function () {
      try {
        if (!this.franchiseeID || this.franchiseeID === null || this.franchiseeID === '') {
          return this.errMsg('Please select franchisee ')
        }
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/staff/approved`, {
          params: {
            franchiseeID: this.franchiseeID
          }
        })

        let tempArray = []
        console.log(tempArray, 'tempArray')
        _.map(data, obj => {
          tempArray.push({ name: obj.user.firstName + ' ' + obj.user.lastName, id: obj.user.userStaff.userID })
        })
        this.staffData = tempArray

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getCalenderType: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/communication/eventCalender/events`)
        this.calendarTypeArray = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/student/class-section?isRequired=false`)
        if (data) {
          this.classes = data.map(obj => {
            return {
              id: obj.id,
              name: obj.name
            }
          })
          this.sections = data.map(obj => {
            return {
              id: obj.id,
              name: obj.name,
              sections: obj.studentSections
            }
          })
        }
        data.map(a => {
          a.studentSections.map(b => {
            this.tempArray.push({
              id: b.id,
              name: `${a.name}-${b.name}`
            })
          })
        })
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    changeSections: async function () {
      this.selectedStudent = []
      this.studentArray = []
      try {
        this.isLoading = true
        let sectionarray = this.sections.find(obj => obj.id === this.selectedClassID)
        if (sectionarray) {
          this.classWiseSections = sectionarray.sections
        } else {
          this.classWiseSections = 0
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    students: async function () {
      if (!this.franchiseeID || this.franchiseeID === null || this.franchiseeID === '') {
        return this.errMsg('Please select franchisee ')
      }
      this.selectedStudent = []
      this.studentArray = []
      let studentData = {
        isActive: 'true',
        franchiseeID: this.franchiseeID,
        classID: this.selectedClassID,
        sectionID: this.selectedSectionID,
        academicYearID: this.academicYearID
      }
      try {
        this.isLoading = true
        let { data } = await http.post(`${constants.API_URL}/api/student`, studentData)
        if (data.length === 0) {
          this.$dialog.notify.warning(`No student Found with selected class and section`, {
            position: 'top-right',
            timeout: 5000
          })
        } else {
          this.studentArray = data.map(a => {
            return {
              id: a.id,
              name: a.studentEnrollment.studentName
            }
          })
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    },
    save: async function () {
      if (!this.franchiseeID || this.franchiseeID === null || this.franchiseeID === '') {
        return this.errMsg('Please select franchisee ')
      }
      let formData = new FormData()
      formData.append('franchiseeID', this.franchiseeID)
      formData.append('academicYearID', this.academicYearID)
      formData.append('eventColorID', this.calendarID)
      formData.append('startDate', this.fromDate)
      formData.append('endDate', this.fromDate)
      formData.append('descriptions', this.discription)
      if (this.calendarID !== 2) {
        formData.append('title', this.title)
        formData.append('subTitle', this.subTitle)
      }
      if (this.calendarID === 2 && this.UserType === 'STAFF') {
        formData.append('eventReferenceType', 'STAFF')
        formData.append('eventReferenceID', this.staffID.id)
        formData.append('title', this.staffID.name)
        formData.append('subTitle', this.anyMassage)
      }
      if (this.calendarID === 2 && this.UserType === 'STUDENT') {
        formData.append('eventReferenceType', 'STUDENT')
        formData.append('eventReferenceID', this.selectedStudent.id)
        formData.append('title', this.selectedStudent.name)
        formData.append('subTitle', this.anyMassage)
      }
      formData.append('file', this.dropFile)
      this.hasClicked = true
      try {
        this.isLoading = true
        await http.post(`${constants.API_URL}/api/communication/eventCalender`, formData)
        this.loader = false
        this.isLoading = false
        this.$router.push({ name: 'eventCalendarList' })
        return this.$dialog.info({
          text: 'Saved successfully',
          title: 'Success'
        })
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    onFilechange () {
      let r = this.dropFile.type !== 'image/jpeg' && this.dropFile.type !== 'image/jpg' && this.dropFile.type !== 'image/png'
      if (r === true) {
        this.dropFile.pop()
        return this.$dialog.error({
          text: 'please select jpeg , jpg , png format only',
          title: 'Error'
        })
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    clearbithdayData () {
      if (this.UserType === 'STAFF') {
        if (!this.franchiseeID || this.franchiseeID === null || this.franchiseeID === '') {
          return this.errMsg('Please select franchisee ')
        }
        this.getStaff()
      }
      this.title = ''
      this.subTitle = ''
      this.discription = ''
      this.selectedSectionID = ''
      this.selectedClassID = ''
      this.selectedStudent = ''
      this.staffID = ''
      this.studentbirthdate = ''
      this.fromDate = moment().format('YYYY-MM-DD')
      this.anyMassage = ''
    },
    clearAllData () {
      this.title = ''
      this.subTitle = ''
      this.discription = ''
      this.selectedSectionID = ''
      this.selectedClassID = ''
      this.UserType = ''
      this.selectedStudent = ''
      this.staffID = ''
      this.fromDate = moment().format('YYYY-MM-DD')
      this.studentbirthdate = ''
      this.anyMassage = ''
    },
    clear () {
      this.calendarID = ''
      this.title = ''
      this.subTitle = ''
      this.discription = ''
      this.selectedSectionID = ''
      this.selectedClassID = ''
      this.selectedStudent = ''
      this.staffID = ''
      this.fromDate = moment().format('YYYY-MM-DD')
      this.UserType = ''
      this.studentbirthdate = ''
      this.anyMassage = ''
    }
  }
}
</script>
